module.exports = "/_next/static/videos/tennis-2-2705c09f6f6ba5e23987f27ae08da126.webm";